import axios from "axios";
import qs from "qs";
import { IRequestConfig, MethodsTypes } from "models/Axios";
import { IBatchRequestResponse } from "models/Batch";
import authServices from "core/authentication/authService";

export default class Services<TEntityResponse, TRequestConfig> {
  _authServices = new authServices();

  base_url = process.env.REACT_APP_API_BASE_URL;

  mafraq_url = process.env.REACT_APP_API_MAFRAQ_URL;
  mafraq_url2 = process.env.REACT_APP_API_MAFRAQ_URL2;

  access_token = () => this._authServices.credentials()?.access_token;

  private defaultConfigs: IRequestConfig<
    IBatchRequestResponse<TEntityResponse>
  > = {
      method: MethodsTypes.get,
      url: this.base_url,
      timeout: 35000,
      params: {},
      headers: { "Content-Type": "application/json" },
    };

  private updateConfigs = (configs: IRequestConfig<TRequestConfig>) => ({
    ...this.defaultConfigs,
    method: configs?.method,
    url: `${configs.baseUrl
      ? configs.baseUrl + configs.url
      : this.base_url + (configs?.url || "")
      }`,
    paramsSerializer: configs?.paramsSerializer,
    params: configs?.params,
    headers: Object.assign(
      configs?.headers || {},
      this.defaultConfigs.headers,
      {
        Authorization: `Bearer ${this.access_token()}`,
      }
    ),
    data: configs?.data && qs.stringify(configs?.data || {}),
    timeout: configs?.timeout ?? 35000
  });

  protected httpRequest = async (
    config?: IRequestConfig<TRequestConfig>,
    params?: {}
  ) => {
    const configs = Object.assign(
      config ? this.updateConfigs(config) : this.defaultConfigs,
      params || {}
    );

    return await axios(configs)
      .then((result) => result.data)
      .catch((error) => {
        if (error?.response?.status === 401) {
          if (window.location.href !== String(process.env.REACT_APP_HOME_URL)) {
            window.location.replace(String(process.env.REACT_APP_HOME_URL));
          }
        }

        if (error?.response?.status === 503) {
          window.location.replace(String(process.env.REACT_APP_MAINTENANCE_URL));
        }

        return {
          error: true,
          errorMessage: error?.response?.data?.data,
          data: undefined,
          totalPages: 0,
          pageSize: 0,
          total: 0,
        };
      });
  };
}
